module.exports = __webpack_public_path__ + "static/media/chat08.3914187a.gif";